import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import Button from '../../components/Button'
import useFeedback from './useFeedback'

const Feedback = () => {
  const { feedback, handleSend, setFeedback, isLoading } = useFeedback()

  return (
    <DashboardLayout className="absolute">
      <div className="ml-auto mr-auto mb-1 max-w-[700px] rounded-lg bg-secondary-background mt-[10vh] p-[20px]">
        <h1 className="font-bold text-over-primary-background text-2xl">
          Ai vreo sugestie pentru imbunatatirea platformei?
        </h1>
        <p className="text-over-primary-background text-sm">
          Contactează-ne prin formularul de mai jos! Citim fiecare mesaj și
          apreciem feedbackul tău. Dacă întâmpini probleme, spune-ne - le
          rezolvăm rapid. Mulțumim că ești alături de noi!
        </p>
        <div className="flex flex-col mt-[20px]">
          <label
            htmlFor="message"
            className="text-over-primary-background mb-[2px]"
          >
            Mesajul tau
          </label>
          <textarea
            id="message"
            name="message"
            placeholder="Am vazut ca la pagina..."
            value={feedback}
            onChange={event => setFeedback(event.target.value)}
            className="bg-primary-background rounded w-full max-w-[500px] p-2 h-[150px] min-h-[150px] max-h-[220px] text-sm outline-none border-2 text-over-primary-background"
          />
        </div>
        <Button
          className="bg-primary mt-[10px] w-[100px]"
          onClick={handleSend}
          isLoading={isLoading}
        >
          Trimite
        </Button>
        <hr className="my-[18px] w-[100%] max-w-[300px] h-[2px] bg-over-primary-background border-none outline-none opacity-10" />
        <p className="text-over-primary-background text-md">
          Sau contactează-ne direct pe whatsapp!
        </p>
        <div className="flex flex-row gap-[7px] mt-[7px]">
          <img
            src="https://grile.info/home/images/whatsapp.webp"
            className="w-[18px] h-[18px] translate-y-[2px]"
          />
          <div className="flex flex-col text-sm text-over-primary-background">
            <a
              href="https://wa.me/+40740764496"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp Mihai: 0740 764 496
            </a>
            <a
              href="https://wa.me/+40762366010"
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp Cristi: 0762 366 010
            </a>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default Feedback
